import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuthStore } from "../store/store";
import styled from "styled-components"
import AdminMenu from "./AdminMenu";
import PageHeader from "../components/PageCloseButton";
import FormatPrice from '../Helpers/FormatPrice'

import moment from "moment"
import { NavLink } from "react-router-dom";

const AdminOrdersPage = () => {
  const token = useAuthStore((state) => state.auth?.token);
  const [orders, setOrders] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get("/api/orders/all", {
          headers: { Authorization: `Bearer ${token}` }
        });
        setOrders(response.data);
      } catch (err) {
        console.error("Error fetching orders:", err);
        setError("Failed to load orders");
      }
    };

    if (token) fetchOrders();
  }, [token]);

  if (error) return <p>{error}</p>;
  if (!orders.length) return <p>No orders found</p>;

 // Sort orders by date
   const sortedOrders = [...orders].sort((a, b) => {
     const dateA = moment(a.createdAt).valueOf();
     const dateB = moment(b.createdAt).valueOf();
     return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
   }); 

   const handleStatusChange = async (orderId, newStatus) => {
  try {
    await axios.put(
      `/api/orders/${orderId}/status`,
      { status: newStatus },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setOrders((prevOrders) =>
      prevOrders.map((order) =>
        order._id === orderId ? { ...order, status: newStatus } : order
      )
    );
  } catch (err) {
    console.error("Error updating status:", err.response?.data || err.message);
    alert("Failed to update status");
  }
};

  return (
     <Wrapper>
    <div className="grid grid-two-column">
      <AdminMenu />
    <div className="order-container">
       <PageHeader title="Orders" /> 
       <div className="table-container">
      <table>
        <thead>
          <tr>
             <th
              onClick={() =>
              setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
              }
              style={{ cursor: "pointer" }}
              >
              Date {sortOrder === "asc" ? "▲" : "▼"}
            </th>
            <th>Order Number</th>
            <th>Buyer</th>
            <th>E-mail</th>
            <th>Amount</th>
            <th>Payment</th>
            <th>Status</th>
            </tr>
        </thead>
        <tbody>
          {sortedOrders.map((order) => (
            <tr key={order._id}>
              <td>{moment(order.createdAt).format("DD/MM/YYYY")}</td>
              <td><NavLink to={`/orderprint/${order._id}`}>{order.orderNumber}</NavLink></td>
              <td>{order.buyer?.name || "N/A"} </td> 
              <td> {order.buyer?.email}</td>
              <td><FormatPrice price={order.orderTotal} /></td>
              <td>{order.payment}</td>
              <td>
                <select
                  value={order.status}
                  onChange={(e) => handleStatusChange(order._id, e.target.value)}>
                  <option value="Pending">Pending</option>
                  <option value="ProformaSend">Proforma sent</option>
                  <option value="Processing">Processing</option>
                  <option value="Shipped">Shipped</option>                  
                  <option value="Email">Email</option>
                  <option value="Delivered">Delivered</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
    </div>
    </Wrapper>
  );
};
const Wrapper = styled.div`
 
.grid-two-column{
    display: grid;
    grid-template-columns: 2fr 8fr; 
    gap: 2rem;
    }

.order-container {  
    padding: 2rem;
    }

.table-container {
    margin-top:2rem;
    margin-bottom:2rem;
    max-height: 400px; /* adjust as needed */
    overflow-y: auto;
    border: 1px solid #ddd;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    }
  

table {
    margin:2rem ;
    width: 97%;
    border-collapse: collapse;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    }
 
thead {
    background-color:${({ theme }) => theme.colors.font};
    color: #fff;
    }

thead th {
    position: sticky;
    top: 0;
    padding: 12px;
    font-size: 14px;
    text-align: left;
    letter-spacing: 0.5px;
    z-index: 2; /* ensures header stays above rows */
    }

thead th.sortable {
    cursor: pointer;
    }

tbody tr {
    border-bottom: 1px solid #eee;
    transition: 0.2s ease;
    }

tbody tr:hover {
    background-color: #f9f9f9;
   }

td {
    padding: 12px;
    font-size: 14px;
    vertical-align: top;
    }

td div {
    margin-bottom: 4px;
    }

 
@media (max-width: ${({ theme }) => theme.media.mobile}) {

.grid-two-column {
    grid-template-columns: 1fr;
    }  
 table{
   display: block; 
   width: 90%;
  }

  thead, tbody, th, td, tr {
    display: block; 
    }

thead {
    display: none;
    }

tr {
     margin-bottom: 1rem;
    border: 1px solid #d7d5d5;
    border-radius: 8px;
    padding: 6px;
    }

td {    
      border: none;
      position: relative;
      padding: 0.5rem 0.5rem 0.5rem 1rem;
     }

tbody tr td::before {
    content: attr(data-label);
    font-weight: bold;
     left: 0.2rem;
    position: absolute;
    } 
}
`;
export default AdminOrdersPage;